import * as Sentry from "@sentry/angular";

import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { ENV } from "./app/app.runtime";
import { NWD_VERSION } from "./version";

if (ENV.SENTRY_DSN !== "") {
  Sentry.init({
    dsn: ENV.SENTRY_DSN,
    release: NWD_VERSION,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Registers the Replay integration,
      // which automatically captures Session Replays
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: [/^https:\/\/netwerkdashboard(.*)?.surf.((net)|(nl))/, ENV.NWD_API_BASE_URL],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  // something happened, causing the Angular app to fail.
  console.warn("Something went awry: ", err);
  // last resort: a static error page.
  window.location.href = "/assets/error.html";
});
